function SortingGuide() {
  return (
    <div className="small">
      <div>
        ソートのために、マウスとキーボードの両方を使用することができます。マウスを使用すると、ターゲットの行をドラッグアンドドロップできます。キーボードを使用する場合、以下のように操作ください:
      </div>
      <div>
        <ul>
          <li>[タブキー] または [shift + タブキー] を使用して、ターゲットの行にフォーカスします。</li>
          <li>[スペースキー] を使用して、選択した行を確認します。</li>
          <li>[上矢印キー] または [下矢印キー] を使用して、選択した行を移動します。</li>
          <li>アクションの移動を終了したい場合は、再度 [スペースキー] を押します。</li>
        </ul>
      </div>
    </div>
  );
}

export default SortingGuide;
